import {axiosNodeClient} from "../http";

export const messageWelcomeServiceNode = {create, update, getAllStep}

function create(steps) {
    return axiosNodeClient.post(`/message/welcome`, steps);
}

function update(steps) {
    return axiosNodeClient.put(`/message/welcome`, steps);
}

function getAllStep() {
    return axiosNodeClient.get(`/message/welcome`);
}
